import SearchBar from './SearchBar';
import SearchBarContainer from './SearchBar.container';

export default SearchBarContainer(SearchBar);
